// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueLazyload from 'vue-lazyload'
import VueLocalStorage from 'vue-ls'

var options = {
  namespace: 'vuejs__'
}

Vue.use(VueLocalStorage, options)

Vue.config.productionTip = false

Vue.use(VueLazyload, {
  preLoad: 1,
  error: '/static/images/loading-wheel.svg',
  loading: '/static/images/loading-wheel.svg',
  attempt: 1
})

Vue.filter('toYear', function(value) {
  var m = value.match(/\b(\d\d\d\d)\b/)
  if (m) {
    return m[1]
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js